import { Head } from 'vite-react-ssg'
import Header from '../components/Header'
import Hero from '../components/Hero'
import StartHere from '../components/StartHere'
import ArticleGrid from '../components/ArticleGrid'
import Pillars from '../components/Pillars'
import Readiness from '../components/Readiness'
import Consensus from '../components/Consensus'
import Authors from '../components/Authors'
import Newsletter from '../components/Newsletter'
import Footer from '../components/Footer'
import { featuredArticle, articles } from '../data/articles'

export default function Home() {
  // Real count of published articles. Update this once articles are fetched
  // from WordPress at build time instead of bundled in data/articles.ts.
  const articleCount = 1 + articles.length

  return (
    <div className="os-root">
      <Head>
        <title>Original Savage · Be Prepared. Stay Savage.</title>
        <meta
          name="description"
          content="Modern, no-nonsense prepping and self-sufficiency: food & water storage, off-grid power, skills, gear, and honest readiness guides."
        />
        <link rel="canonical" href="https://originalsavage.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Original Savage: Be Prepared. Stay Savage." />
        <meta
          property="og:description"
          content="Modern, no-nonsense prepping and self-sufficiency: food & water storage, off-grid power, skills, gear, and honest readiness guides."
        />
        <meta property="og:url" content="https://originalsavage.com/" />
        <meta property="og:image" content="https://originalsavage.com/brand/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Original Savage: Be Prepared. Stay Savage." />
        <meta
          name="twitter:description"
          content="Modern, no-nonsense prepping and self-sufficiency: food & water storage, off-grid power, skills, gear, and honest readiness guides."
        />
        <meta name="twitter:image" content="https://originalsavage.com/brand/og-image.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                '@id': 'https://originalsavage.com/#organization',
                name: 'Original Savage',
                url: 'https://originalsavage.com/',
                logo: 'https://originalsavage.com/brand/logomark.svg',
                slogan: 'Be Prepared. Stay Savage.',
              },
              {
                // No potentialAction/SearchAction here — the site has no real
                // on-site search, and that schema is specifically for sites
                // that do (it can surface a Google sitelinks searchbox that
                // would silently do nothing here).
                '@type': 'WebSite',
                '@id': 'https://originalsavage.com/#website',
                name: 'Original Savage',
                url: 'https://originalsavage.com/',
                publisher: { '@id': 'https://originalsavage.com/#organization' },
              },
            ],
          })}
        </script>
      </Head>
      <Header />
      <main id="main">
        <Hero articleCount={articleCount} />
        <StartHere />
        <ArticleGrid featured={featuredArticle} rest={articles} />
        <Pillars />
        <Readiness />
        <Consensus />
        <Authors />
        <Newsletter />
      </main>
      <Footer />
    </div>
  )
}
